import styled from "styled-components";

export const CardFooterIndicator = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
`;
